<template>
  <fragment>
    <app-header :title="mediaOwner.name"/>
    <slot name="nav"/>

    <div class="container container-max-sm">
      <form class="card" @submit.prevent>
        <validation-observer tag="div" class="card-body card-body-lg" @submit.native.prevent ref="validation">
          <h2 class="card-title">FTP Connection Details</h2>

          <p>Setup FTP client connection details for this media owner.</p>
          <p>Then enable the connection for each screens camera you would like to connect to.</p>
          <validation-provider
            tag="div"
            class="mb-3"
            name="FTP Host"
            rules="required"
          >
            <label>FTP Host</label>
            <c-input type="text" v-model="stateFtpConnectionFtpHost" />
            <c-help-block />
          </validation-provider>

          <validation-provider
            tag="div"
            class="mb-3"
            name="FTP Username"
            rules="required"
          >
            <label>FTP Username</label>
            <c-input type="text" v-model="stateFtpConnectionFtpUsername" />
            <c-help-block />
          </validation-provider>

          <validation-provider
            tag="div"
            class="mb-3"
            name="FTP Password"
            rules="required"
          >
            <label>FTP Password</label>
            <c-input type="text" v-model="stateFtpConnectionFtpPassword" />
            <c-help-block />
          </validation-provider>

          <validation-provider
            tag="div"
            class="mb-3"
            name="FTP Mode"
            rules="required"
          >
            <label>FTP Mode</label>
            <c-input
              as="multiselect"
              :class="invalidClass"
              v-model="stateFtpConnectionFtpMode"
              placeholder="Select"
              :options="options"
            />
            <c-help-block />
          </validation-provider>

          <div class="row">
            <div class="col-auto">
              <c-button @click="handleSave" variant="primary" validate>
                Save
              </c-button>
            </div>
          </div>
        </validation-observer>
        </form>
    </div>
  </fragment>
</template>

<script>
import { get, call } from 'vuex-pathify'
import { pick } from 'lodash'
import { stateMapper } from '@/vuex/modules/media-owners'

export default {
  mixins: [stateMapper],
  components: {
  },

  computed: {
    ...get('mediaOwners', ['mediaOwner'])
  },

  data () {
    return {
      options: ['FTP', 'FTPS'] // 'SFTP' - removed as not yet tested.
    }
  },

  methods: {
    ...call('mediaOwners', ['updateMediaOwner']),

    async handleSave () {
      const payload = pick(this.mediaOwner, [
        'ftp_connection'
      ])

      await this.updateMediaOwner({ id: this.mediaOwner.id, payload: payload })
    }
  }
}
</script>
